<template>
  <div class="enter-package flexbox vertical">
    <header class="page-header flexbox space-bt">
      <van-icon name="arrow-left" @click="$router.go(-1)" />
      <span>{{ $t('PackageEdit.编辑包裹') }}</span>
      <van-icon name="ellipsis" class="text-white" />
    </header>
    <main class="flex-fill page-body">
      <div class="form round">
        <van-cell :title="$t('PackageEdit.快递单号')" :value="orderNo" />
        <van-field
          :label="$t('PackageEdit.物品名称')"
          v-model="name"
        ></van-field>
        <van-field :label="$t('PackageEdit.备注')" v-model="note"></van-field>
        <van-field
          v-if="appTitle != 'Love Logistic'"
          :label="$t('PackageEdit.申报货值')"
          v-model="declarePrice"
        ></van-field>
        <van-cell
          :title="$t('建档日期')"
          :value="this.packageInfo.createtime"
        />
        <van-cell
          :title="$t('状态')"
          :value="$t(packageStatus[this.packageInfo.istatus])"
        />
      </div>
      <div class="note">
        {{ $t('PackageEdit.修改包裹提示信息') }}
      </div>
      <div class="footer-btn" v-if="packageInfo.istatus !== 1">
        <van-button type="info" @click="onSubmit">{{
          $t('PackageEdit.保存')
        }}</van-button>
      </div>

      <van-divider />
      <van-tabs v-model="active">
        <van-tab :title="$t('Order.轨迹')">
          <div class="bg-white" v-if="tracks.length">
            <timeline>
              <timeline-title>
                <div>{{ tracks[0].sNote }}</div>
                <div class="track-en">{{ tracks[0].sEnNote }}</div>
                <div class="f-12 time">{{ tracks[0].time }}</div>
              </timeline-title>
              <timeline-item
                v-for="(item, index) in tracks.slice(1)"
                :key="index"
              >
                <div>{{ item.sNote }}</div>
                <div class="track-en">{{ item.sEnNote }}</div>
                <div class="time f-12">{{ item.time }}</div>
              </timeline-item>
            </timeline>
          </div>
          <div class="bg-white set-center" v-else>
            <img :src="emptyImg" class="noimg" />
            <div>{{ $t('暂无轨迹，请输入运单号查询') }}</div>
          </div>
        </van-tab>
        <van-tab :title="$t('货物明细')">
          <van-cell-group v-if="packageLineList != null">
            <van-cell
              v-for="item in packageLineList"
              :key="item.PK_ID"
              :title="`${$t('PackageEdit.箱号')}: ${item.sBagNo}`"
              :value="`${$t('PackageEdit.品名')}: ${item.sName}`"
              :label="`${$t('PackageEdit.材质')}: ${item.sMaterialQuantity}`"
            />
          </van-cell-group>
          <div class="bg-white set-center" v-else>
            <img :src="emptyImg" class="noimg" />
            <div>{{ $t('没有货物明细') }}</div>
          </div>
        </van-tab>
        <van-tab :title="$t('货物照片')">
          <div class="bg-white">
            <van-image
              class="van-image-qsoa"
              fit="fill"
              :src="packageInfo.sPicUrl"
              @click="onImgPreview(packageInfo.sPicUrl)"
              width="1.5rem"
              height="1.5rem"
              padding="0.2rem"
            />
            <van-image
              class="van-image-qsoa"
              v-for="(imgItem, index) in packageInfo.packageFilesList"
              fit="fill"
              :key="index"
              :src="imgItem.sUrl"
              @click="onImgPreview(imgItem.sUrl)"
              width="1.5rem"
              height="1.5rem"
              padding="0.2rem"
            />
          </div>
          <div
            class="bg-white set-center"
            v-show="
              packageInfo.sPicUrl == null ||
                packageInfo.packageFilesList == null ||
                packageInfo.packageFilesList.length == 0
            "
          >
            <img :src="emptyImg" class="noimg" />
            <div>{{ $t('没有更多的图片') }}</div>
          </div>
        </van-tab>
      </van-tabs>
    </main>
  </div>
</template>
<script>
import { editPkgGoods, getPackageInfoByID } from '@/api/deliver.js';
import { getValidTime } from '@/utils/index.js';
import { ImagePreview } from 'vant';
import Vue from 'vue';
import { Image as VanImage } from 'vant';

Vue.use(VanImage);
export default {
  data() {
    return {
      packageInfo: {},
      active: 0,
      pkgid: 0,
      orderNo: '',
      name: '',
      note: '',
      declarePrice: 0,
      packageLineList: [],
      emptyImg: require('../../assets/images/noinfo.png'),
      tracks: [],
      packageStatus: {
        '-1': '待入库',
        '0': '已入库',
        '1': '已发货',
      },
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.pkgid = this.$route.query.id;
      getPackageInfoByID(this.pkgid).then(res => {
        if (res.Result == true) {
          var packInfo = res.DataDict['data'];
          console.log(packInfo);
          this.name = packInfo.goods_name;
          this.note = packInfo.remark;
          this.orderNo = packInfo.delivery_no;
          this.declarePrice = packInfo.single_price;
          this.packageLineList = packInfo.packageLineList;
          this.packageInfo = packInfo;
          this.packageInfo.createtime = getValidTime(packInfo.createtime);
          packInfo.trackInfoList.forEach(element => {
            this.tracks.push({
              sNote: element.sNote,
              sEnNote: element.sEnNote,
              time: getValidTime(element.dCreateTime),
            });
          });
        }
      });
    },
    onImgPreview(imgurl) {
      if (imgurl == '' || imgurl == null) {
        return;
      }
      ImagePreview([imgurl]);
    },
    reset() {
      this.pkgid = 0;
      this.orderNo = '';
      this.name = '';
      this.note = '';
      this.declarePrice = 0;
    },
    onSubmit() {
      editPkgGoods({
        id: this.pkgid,
        amount: this.declarePrice,
        gname: this.name,
        note: this.note,
      }).then(res => {
        if (res.Result) {
          this.$toast(res.Info);
          setTimeout(() => {
            this.$router.go(-1);
          }, 1500);
        } else {
          this.$toast.fail(res.Info);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/styles/_var';
.page-body {
  padding: rem(20px);
}
.round {
  border-radius: rem(10px);
}
.noimg {
  width: auto;
  height: rem(150px);
}
.note {
  color: #b8b8b8;
  font-size: 12px;
  line-height: 1.5;
  margin: rem(20px) 0;
}
.van-image {
  margin: 5px;
}
.van-button {
  height: rem(80px);
  width: rem(500px);
  background-color: $theme-color;
  border: none;
  border-radius: rem(25px);
}
.x-center {
  margin: rem(40px) 0;
}
.address {
  background: rgba(#9c9bb4, 0.3);
  padding: rem(20px);
  padding-bottom: rem(40px);
}

.indent {
  margin-left: rem(40px);
  line-height: 2;
}
.tip {
  padding: rem(32px);
  background: #f6f6f6;
  border-radius: rem(10px);
}
.text-white {
  color: #fff;
}

.footer-btn {
  width: 90%;
  margin: rem(10px) rem(20px);
  text-align: center;
}

.bg-white {
  background: #fff;
  padding: 5px;
  margin: 0px;
  border-radius: 5px;
}

/deep/ .timeline-title-circle {
  background-color: $theme-color;
}
/deep/ .timeline-item {
  border-bottom: 1px solid #f6f6f6;
}
.time {
  color: #666;
  font-size: 12px;
  margin-top: rem(20px);
}
.track-en {
  color: #979797;
}

.tab-padding {
  margin: rem(20px);
}
</style>
